import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { async } from 'regenerator-runtime';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { gtag4 } from '../../../utilities/analytics/tracking';

export const MovingApartmentExecution = createAsyncThunk('movingBlock/MovingApartmentExecution', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  let upgradeToFiber = isUpgradeToFiber(state);
  let workOrderCode = upgradeToFiber ? "MOV2" : "CB23"; //General Error
  let workOrderReason = upgradeToFiber ? "סיבה 10 - שגיאה אפליקטיבית - אפשרי לשדרג לסיבים " : "סיבה 9 - שגיאה אפליקטיבית ";//General Error
  try {
    let contactNumber = '';
    if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
      contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
    } else {
      contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
    }

    thunkAPI.dispatch(movingBlockSlice.actions.setIsEndOfProcess(true));

    var params = buildMovingApartmentExecution(state, contactNumber);


    const result = await ProviderManager.getProviderData('moveApartment', params);
    if (result.Body.isSuccess) {
      if (!state.movingApartmentData.isTvApp) {
        thunkAPI.dispatch(movingBlockSlice.actions.goToPage('completePage'));
      }
      return result;
    } else {
      thunkAPI.dispatch(movingBlockSlice.actions.setErrorCode(result.Body.codeError));
      if (result.Body.codeError.startsWith("18521201")) { // 1852
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'סיבה 11 - נדרשת החלפת ציוד בעלות',
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 11 - נדרשת החלפת ציוד בעלות', stepDescription: 'מסך סיכום', memoID: "2" }));
        thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));

      }
      else if (result.Body.codeError.startsWith("18521208") || result.Body.codeError.startsWith("18521207") || result.Body.codeError.startsWith("18521204")) {//שגיאות לגבי מהירות או ציוד
        if (state.movingEpiData.isPinTechnician.value) {
          thunkAPI.dispatch(checkPinTechnician());
        }
        else {
          if (result.Body.codeError.startsWith("18521204")) {//ציוד
            thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה - 11 יש צורך בשינוי ציוד בעקבות שינוי סוג תשתית', stepDescription: 'מסך סיכום', memoID: "1" }));
            thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
          }
          else {//מהירות
            thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 2 - יש צורך בשינוי מהירות, המהירות הקיימת לא נתמכת בכתובת החדשה', stepDescription: 'מסך סיכום', memoID: "1" }));
            thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'OPTICAL_FIBER_FOUNDED' }));
          }
        }
      }
      else if (result.Body.codeError.startsWith("1854")) {
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Create Moving Order',
            status: 'Error',
            messageText: 'General Error',
            products: state.movingApartmentData?.products,
            param2: state.movingApartmentData.address?.fullAddress,
            selectedProducts: state.movingApartmentData?.selectedProducts,
            param4: state.movingApartmentData?.address?.selectedEntry?.infrastructure,
            param5: state.movingApartmentData?.technicianData?.selectedTechnicianTimeSlot?.fullDate,
            param6: state.movingApartmentData?.isCollaborationApproval,
            param7: state.movingApartmentData?.email?.value,
            param8: state.movingApartmentData?.contactDetails?.phone,
            param9: workOrderReason + " - " + "שגיאה בוולידציה ממשק 1854 - " + result.Body.message,
            param10: workOrderCode
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: workOrderCode, reason: workOrderReason + " - " + "שגיאה בוולידציה ממשק 1854 - " + result.Body.message, stepDescription: 'מסך סיכום', memoID: "1" }));
        thunkAPI.dispatch(createWorkOrder({ code: workOrderCode, reason: workOrderReason + " - " + "שגיאה בוולידציה ממשק 1854 - " + result.Body.message, stepDescription: 'מסך סיכום', memoID: "1" }));
        thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID('LAST_DETAILS'));
        thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
      } else if (result.Body.codeError.startsWith("1550") || result.Body.codeError.startsWith("0865")) {
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'סיבה 7 - שגיאה ביצירת הזמנה ב-IIP ',
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'MOV3', reason: 'סיבה 7 - שגיאה ביצירת הזמנה ב-IIP ' + result.Body.message, stepDescription: 'מסך סיכום', memoID: "2" }));
        thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
      } else if (result.Body.codeError.startsWith("1784")) {
        if (state.movingApartmentData.selectedProductWithEquipment == 'internet') {
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 9 - שגיאה אפליקטיבית - ממשק 1784' + " - " + result.Body.message, stepDescription: 'מסך סיכום' }));
          thunkAPI.dispatch(createWorkOrder({ code: 'CB23', reason: 'סיבה 9 - שגיאה אפליקטיבית - ממשק 1784' + " - " + result.Body.message, stepDescription: 'מסך סיכום' }));
        } else if (state.movingApartmentData.selectedProductWithEquipment == 'tv') {
          thunkAPI.dispatch(
            movingBlockSlice.actions.report({
              actionType: 'Create Moving Order',
              status: 'Error',
              messageText: 'General Error',
              products: state.movingApartmentData.products,
              param2: state.movingApartmentData.address?.fullAddress,
              selectedProducts: state.movingApartmentData.selectedProducts,
              param4: state.movingApartmentData?.address?.selectedEntry?.infrastructure,
              param5: state.movingApartmentData?.technicianData?.selectedTechnicianTimeSlot?.fullDate,
              param6: state.movingApartmentData.isCollaborationApproval,
              param7: state.movingApartmentData.email?.value,
              param8: state.movingApartmentData.contactDetails?.phone,
              param9: workOrderReason + "- ממשק 1784 - " + result.Body.message,
              param10: workOrderCode
            })
          );
          thunkAPI.dispatch(
            createWorkOrder({
              code: workOrderCode,
              reason: workOrderReason + "- ממשק 1784 - " + result.Body.message,
              stepDescription: 'מסך סיכום',
              memoID: "1"
            }));
        }
        thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: workOrderCode, reason: workOrderReason + "- ממשק 1784 - " + result.Body.message, stepDescription: 'מסך סיכום', memoID: "1" }));
        thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
      }
      else {
        const interfaceNumber = (result.Body?.codeError && result.Body?.codeError?.length >= 4) ? result.Body.codeError.substring(0, 4) : "";
        if (!state.movingApartmentData.movingWithTechnician) {
          thunkAPI.dispatch(
            movingBlockSlice.actions.report({
              actionType: 'Address Update',
              status: 'Error',
              messageText: 'General Error',
              products: state.movingApartmentData.products,
              param2: state.movingApartmentData.address.fullAddress,
              param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
              param6: state.movingApartmentData.isCollaborationApproval,
              param7: state.movingApartmentData.email?.value,
              param8: state.movingApartmentData.contactDetails?.phone,
              param9: workOrderReason + " - ממשק - " + interfaceNumber + ' - ' + result.Body.message,
            })
          );
          thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR_1')); //ERROR SCREEN 6
        } else {
          thunkAPI.dispatch(
            movingBlockSlice.actions.report({
              actionType: 'Create Moving Order',
              status: 'Error',
              messageText: 'General Error',
              products: state.movingApartmentData.products,
              param2: state.movingApartmentData.address.fullAddress,
              selectedProducts: state.movingApartmentData.selectedProducts,
              param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
              param5: state.movingApartmentData?.technicianData?.selectedTechnicianTimeSlot?.fullDate,
              param6: state.movingApartmentData.isCollaborationApproval,
              param7: state.movingApartmentData.email?.value,
              param8: state.movingApartmentData.contactDetails?.phone,
              param9: workOrderReason + " - ממשק - " + interfaceNumber + ' - ' + result.Body.message,
              param10: workOrderCode
            })
          );
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: workOrderCode, reason: workOrderReason + " - ממשק - " + interfaceNumber + ' - ' + result.Body.message, stepDescription: 'מסך סיכום', memoID: "1" }));
          thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
        }
      }
    }
  } catch (error) {
    switch (error.errorCode) {
      case 600: //MOVING_APARTMENT_GENERAL_ERROR
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: state.movingApartmentData.movingWithTechnician ? 'Create Moving Order' : 'Address Update',
            status: 'Error',
            messageText: 'General Error',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param5: state.movingApartmentData?.technicianData?.selectedTechnicianTimeSlot?.fullDate,
            param6: state.movingApartmentData.isCollaborationApproval,
            param7: state.movingApartmentData.email?.value,
            param8: state.movingApartmentData.contactDetails?.phone,
            param9: workOrderReason,
            param10: workOrderCode
          })
        );
        if (state.movingApartmentData.movingWithTechnician) {
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: workOrderCode, reason: workOrderReason, stepDescription: 'מסך סיכום', memoID: "1" }));
          thunkAPI.dispatch(createWorkOrder({ code: workOrderCode, reason: workOrderReason, stepDescription: 'מסך סיכום', memoID: "1" }));
        }
        thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
        break;
      case 601: //MOVING_APARTMENT_JET_ERROR
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'סיבה 5 - מוצר שלא הוסב לJET אפשרי לשדרג לסיבים ',
          })
        );
        if (state.movingApartmentData.movingWithTechnician) {
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 5 - מוצר שלא הוסב לJET אפשרי לשדרג לסיבים ', stepDescription: 'מסך סיכום', memoID: "2" }));
          thunkAPI.dispatch(
            createWorkOrder({ code: 'CB23', reason: 'סיבה 5 - מוצר שלא הוסב לJET אפשרי לשדרג לסיבים ', stepDescription: 'מסך סיכום', memoID: "2" })
          );
        }
        thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
        break;
      case 602: //MOVING_APARTMENT_SAME_ADDRESSES
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'אותה הכתובת',
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
        break;
      case 603: //MOVING_APARTMENT_HAS_DEBT_AND_PAYMENTMETHODISSUE
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'לקוח יש תשלום חוב ועדכון אמצעי תשלום',
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('HAS_DEBT_AND_PAYMENT_METHOD_ISSUE'));
        break;
      case 604: //MOVING_APARTMENT_HAS_DEBT
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'לקוח יש תשלום חוב',
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('HAS_DEBT_ISSUE'));
        break;
      case 605: //MOVING_APARTMENT_HAS_PAYMENTMETHODISSUE
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'לקוח צריך לעדכן אמצעי תשלום',
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('HAS_PAYMENT_METHOD_ISSUE'));
        break;
      case 606: //MOVING_APARTMENT_HAS_OPEN_ORDER
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'קיימת הזמנה אחרת',
          })
        );
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Open Order Exists Message',
            status: 'Service Needed',
            messageText: 'Open Order Exists Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address?.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData.address.selectedEntry?.infrastructure,
          })
        );
        if (state.movingApartmentData.movingWithTechnician) {
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 8 - קיימת הזמנה אחרת', stepDescription: 'מסך סיכום', memoID: "2" }));
          thunkAPI.dispatch(createWorkOrder({ code: 'CB23', reason: 'סיבה 8 - קיימת הזמנה אחרת', stepDescription: 'מסך סיכום', memoID: "2" }));
        }
        gtag4({
          event: 'Moving_Step3_OpenOrderPage',
          title: "בחשבון זה קיימת כבר פניה פתוחה",
          step: '3',
          action: 'OpenOrderPage',
          funnel_name: '1 - MovingWithProducts',
        });
        thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID('OPEN_ORDER'));
        thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
        break;
      case 608: //MOVING_APARTMENT_COPPER_INFRASTCTURE_TO__COPPER_INFRASTCTURE_ERROR
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'סיבה 4 - מעבר מנחושת לנחושת - לשירות',
          })
        );
        if (state.movingApartmentData.movingWithTechnician) {
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 4 - מעבר מנחושת לנחושת - לשירות', stepDescription: 'מסך סיכום', memoID: "2" }));
          thunkAPI.dispatch(createWorkOrder({ code: 'CB23', reason: 'סיבה 4 - מעבר מנחושת לנחושת - לשירות', stepDescription: 'מסך סיכום', memoID: "2" }));
        }
        thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID('LAST_DETAILS'));
        thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
        break;
      case 609: //MOVING_APARTMENT_FIBER_INFRASTCTURE_TO_COPPER_INFRASTCTURE_ERROR
        thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID('LAST_DETAILS'));
        thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
        break;
      case 610: //MOVING_APARTMENT_COPPER_INFRASTCTURE_TO_FIBER_INFRASTCTURE_ERROR
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Redirect to Service Message',
            status: 'Service Needed',
            messageText: 'Redirect to Service Message Displayed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param9: 'סיבה 3 - שדרוג מנחושת לסיבים מכר',
          })
        );
        if (state.movingApartmentData.movingWithTechnician) {
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'MOV2', reason: 'סיבה 3 - שדרוג מנחושת לסיבים מכר', stepDescription: 'מסך סיכום', memoID: "2" }));
          thunkAPI.dispatch(createWorkOrder({ code: 'MOV2', reason: 'סיבה 3 - שדרוג מנחושת לסיבים מכר', stepDescription: 'מסך סיכום', memoID: "2" }));
        }
        thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID('OPTICAL_FIBER_FOUNDED'));
        thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
        break;
      case 614: //MOVING_APARTMENT_DATE_ISNT_AVILABLE
        thunkAPI.dispatch(
          movingBlockSlice.actions.report({
            actionType: 'Create Moving Order',
            status: 'Ongoing',
            messageText: 'Technician Busy New Date Needed',
            products: state.movingApartmentData.products,
            param2: state.movingApartmentData.address.fullAddress,
            selectedProducts: state.movingApartmentData.selectedProducts,
            param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
            param5: state.movingApartmentData?.technicianData?.selectedTechnicianTimeSlot?.fullDate,
            param9: workOrderReason,
            param10: state.movingApartmentData.pinTechnicianDetails?.technicianParams?.addDays ?? '2'
          })
        );
        thunkAPI.dispatch(movingBlockSlice.actions.setTimeSlotNotAvailable(true));
        thunkAPI.dispatch(setTechnicianPage());
        break;
      default:
        if (!state.movingApartmentData.movingWithTechnician) {
          thunkAPI.dispatch(
            movingBlockSlice.actions.report({
              actionType: 'Address Update',
              status: 'Error',
              messageText: 'General Error',
              products: state.movingApartmentData.products,
              param2: state.movingApartmentData.address.fullAddress,
              param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
              param6: state.movingApartmentData?.isCollaborationApproval,
              param7: state.movingApartmentData?.email.value,
              param9: workOrderReason
            })
          );
          thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
        }
        else {
          thunkAPI.dispatch(
            movingBlockSlice.actions.report({
              actionType: 'Create Moving Order',
              status: 'Error',
              messageText: 'General Error',
              products: state.movingApartmentData.products,
              param2: state.movingApartmentData.address?.fullAddress,
              selectedProducts: state.movingApartmentData.selectedProducts,
              param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
              param5: state.movingApartmentData?.technicianData?.selectedTechnicianTimeSlot?.fullDate,
              param6: state.movingApartmentData.isCollaborationApproval,
              param7: state.movingApartmentData.email?.value,
              param8: state.movingApartmentData.contactDetails?.phone,
              param9: workOrderReason,
              param10: workOrderCode
            })
          );
          thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: workOrderCode, reason: workOrderReason, stepDescription: 'מסך סיכום', memoID: "1" }));
          thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
        }
        break;
    }
  } finally {
  }
});
export const GetPriceAndTechnicianType = createAsyncThunk('movingBlock/GetPriceAndTechnicianType', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  thunkAPI.dispatch(showAppLoader());
  try {

    let contactNumber = '';
    if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
      contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
    } else {
      contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
    }
    var params = buildMovingApartmentExecution(state, contactNumber);

    const result = await ProviderManager.getProviderData('GetPriceAndTechnicianType', params);
    thunkAPI.dispatch(movingBlockSlice.actions.setTaskType(result.Body.taskType));

    if (!result.Body.isSuccess) {
      thunkAPI.dispatch(hideAppLoader());
      thunkAPI.dispatch(movingBlockSlice.actions.setErrorCode(result.Body.errorCode));
      if (result.Body.errorCode.startsWith("18521208") || result.Body.errorCode.startsWith("18521207") || result.Body.errorCode.startsWith("18521204")) {//שגיאה לגבי מהירות או ציוד
        if (state.movingEpiData.isPinTechnician.value) {
          await thunkAPI.dispatch(checkPinTechnician());
        }
        else {
          if (result.Body.errorCode.startsWith("18521204")) {//ציוד
            thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה - 11 יש צורך בשינוי ציוד בעקבות שינוי סוג תשתית', stepDescription: 'הצגת עמוד תיאום טכנאי', memoID: "1" }));
            thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
          }
          else {//מהירות
            thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 2 - יש צורך בשינוי מהירות, המהירות הקיימת לא נתמכת בכתובת החדשה', stepDescription: 'הצגת עמוד תיאום טכנאי', memoID: "1" }));
            thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'OPTICAL_FIBER_FOUNDED' }));
          }
        }
      }
      else {
        thunkAPI.dispatch(hideAppLoader());
        thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 9 - שגיאה אפליקטיבית', stepDescription: 'הצגת עמוד תיאום טכנאי', memoID: "1" }));
        thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
      }
    }
    else {
      thunkAPI.dispatch(movingBlockSlice.actions.goToPage('technicianPage'));
    }

    return result?.Body;

  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 9 - שגיאה אפליקטיבית', stepDescription: 'הצגת עמוד תיאום טכנאי', memoID: "1" }));
    thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
  } finally {
  }
});


export const setTechnicianPage = createAsyncThunk('movingBlock/GetPriceAndTechnicianType', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  if (data?.isPinTechnician || state.pinTechnicianDetails?.isTechnician) {
    thunkAPI.dispatch(movingBlockSlice.actions.goToPage('technicianPage'));
  }
  else {
    thunkAPI.dispatch(GetPriceAndTechnicianType());
  }


});

export const getProducts = createAsyncThunk('movingBlock/getProducts', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('getProducts', []);
    thunkAPI.dispatch(movingBlockSlice.actions.goToPage('addressPage'));
    return result?.Body;
  } catch (error) {
    let errorDescription = '';
    if (error.errorCode == 615) {
      errorDescription = 'ללקוח יש הו"ע פתוחה';
      gtag4({
        event: 'Moving_Step3_OpenOrderPage',
        title: "בחשבון זה קיימת כבר פניה פתוחה",
        step: '3',
        action: 'OpenOrderPage',
        funnel_name: '1 - MovingWithProducts',
      });
      thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: false }));
      thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'OPEN_ORDER' }));
    }
    else {
      errorDescription = 'שגיאה כללית בפנייה לממשק לקבלת שירותים ומוצרים ללקוח' +' ' + error.errorCode;
      //TODO: WORKORDER
      thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
    }
    thunkAPI.dispatch(
      movingBlockSlice.actions.report({
        actionType: 'New Address',
        status: 'Error',
        messageText: 'General Error in Receiving Services',
        param8: state.movingApartmentData.contactDetails?.phone,
        param9: errorDescription, //01869 790 796
        //param10:
      })
    );
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
export const checkFiberAddressInfraStructure = createAsyncThunk('movingBlock/checkFiberAddressInfraStructure', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  try {
    thunkAPI.dispatch(showAppLoader());
    const address = thunkAPI.getState().movingBlock.movingApartmentData.address.selectedAddress;
    const entry = thunkAPI.getState().movingBlock.movingApartmentData.address?.selectedEntry?.entry;
    let entryRequest = entry == "ללא שם" ? "NONE" : (entry == null || entry == '') ? ' ' : entry;
    const result = await ProviderManager.getProviderData('checkFiberAddressInfraStructure', [
      address.cityName,
      address.citySemel,
      address.streetName,
      address.streetSemel,
      (address.streetGisSemel ? address.streetGisSemel : '0'),
      address.home,
      entryRequest,
      address.apartment,
    ]);
    return result;
  } catch (error) {
    thunkAPI.dispatch(
      movingBlockSlice.actions.report({
        actionType: "New Address",
        status: 'Error',
        messageText: 'General Error in Address search',
        products: state.movingApartmentData.products,
        param2: state.movingApartmentData.address?.fullAddress,
        param6: state.movingApartmentData.isCollaborationApproval,
        param8: state.movingApartmentData.contactDetails?.phone,
        param9: 'התקבלה שגיאה כללית בממשק 1445 - לאיתור תשתית בכתובת',
        param10: 'CB23'
      })
    );
    thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'התקבלה שגיאה כללית בממשק 1445 - לאיתור תשתית בכתובת', stepDescription: 'מסך הכנסת כתובת חדשה' }));
    thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getAddressEntries = createAsyncThunk('movingBlock/getAddressEntries', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const address = thunkAPI.getState().movingBlock.movingApartmentData.address.selectedAddress;
    const result = await ProviderManager.getProviderData('getAddressEntries', [
      address.cityCode,
      address.streetCode,
      address.home,
    ]);
    return result;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const bezeqCheckTechnicianType = createAsyncThunk('movingBlock/bezeqCheckTechnicianType', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  try {
    thunkAPI.dispatch(showAppLoader());
    const selectedEntry = thunkAPI.getState().movingBlock.movingApartmentData.address.selectedEntry;
    const result = await ProviderManager.getProviderData('bezeqCheckTechnicianType', [
      selectedEntry.internalRequestId,
    ]);
    return result;
  } catch (error) {
    thunkAPI.dispatch(
      movingBlockSlice.actions.report({
        actionType: 'Address Update',
        status: 'Error',
        messageText: 'General Error',
        products: state.movingApartmentData.products,
        param2: state.movingApartmentData.address?.fullAddress,
        param6: state.movingApartmentData.isCollaborationApproval,
        param8: state.movingApartmentData.contactDetails?.phone,
        param9: 'התקבלה שגיאה כללית בממשק 01691 - בדיקת סוג טכנאי בזק',
        param10: 'CB23'
      })
    );
    thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ code: 'CB23', reason: 'התקבלה שגיאה כללית בממשק 01691 - בדיקת סוג טכנאי בזק', stepDescription: 'מסך הכנסת כתובת חדשה' }));
    thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getTechnicianTimeSlots = createAsyncThunk('movingBlock/getTechnicianTimeSlots', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  const movingEpiData = state.movingEpiData;
  try {
    thunkAPI.dispatch(showAppLoader());
    let infrastructure = '';
    let distributionType = '';
    if (state.movingApartmentData.address.selectedEntry) {
      infrastructure = state.movingApartmentData.address.selectedEntry.infrastructure;
      distributionType = state.movingApartmentData.address.selectedEntry.distributionType;
    }

    let addHours = movingEpiData.addHoursTechnicianTimeSlots.value?.toString() ?? '0';

    let taskType = state.movingApartmentData.taskType ?? null;

    if (state.movingApartmentData.pinTechnicianDetails?.technicianParams) {
      infrastructure = '';
      let addDays = state.movingApartmentData.pinTechnicianDetails?.technicianParams?.addDays;
      let isNumeric = /^-?\d+$/.test(addDays);
      if (isNumeric) {
        addHours = (addDays * 24).toString();
        taskType = 'מעבר דירה פוטנציאלי';
      }
    }

    const params = {
      cityName: state.movingApartmentData.address.selectedAddress.cityName,
      cityCode: state.movingApartmentData.address.selectedAddress.cityCode,
      streetCode: state.movingApartmentData.address.selectedAddress.streetCode,
      entrance: state.movingApartmentData.address.selectedAddress.entry,
      houseNumber : state.movingApartmentData.address.selectedAddress.home,
      apartment : state.movingApartmentData.address.selectedAddress.apartment,
      taskType: taskType,
      callId: ' ',
      zipCode: state.movingApartmentData.address.selectedEntry?.zipCode,
      addHours: addHours,
      distributionType: distributionType,
      infrastructure: infrastructure,
    };

    const result = await ProviderManager.getProviderData('getTechnicianTimes', params);
    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(
      movingBlockSlice.actions.report({
        actionType: 'Technician Date',
        status: 'Error',
        messageText: 'General Error in Receiving Tech Slots',
        products: state.movingApartmentData.products,
        param2: state.movingApartmentData.address?.fullAddress,
        selectedProducts: state.movingApartmentData.selectedProducts,
        param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
        param6: state.movingApartmentData.isCollaborationApproval,
        param7: state.movingApartmentData.email?.value,
        param8: state.movingApartmentData.contactDetails?.phone,
        param9: 'שגיאה כללית בפנייה לממשק 1683 לקבלת חלונות זמן לטכנאי',
        param10: 'CB23'
      })
    );
    thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: false, code: 'CB23', reason: 'שגיאה כללית בפנייה לממשק 1683 לקבלת חלונות זמן לטכנאי', stepDescription: 'מסך קבלת חלונות זמן לטכנאי' }));
    thunkAPI.dispatch(whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' }));
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});
export const createWorkOrder = createAsyncThunk('movingBlock/createWorkOrder', async (data, thunkAPI) => {
  try {
    const movingBlock = thunkAPI.getState().movingBlock.movingApartmentData;
    const userDetails = thunkAPI.getState().authentication.loginData.userDetails;
    const workOrder = workOrderRequest(movingBlock, userDetails, data.code, data.reason, data.stepDescription, data.memoID);

    const result = await ProviderManager.getProviderData('createWorkOrder', workOrder);
    return result?.Body;
  } catch (error) { }
});

export const whatsAppActivityStatus = createAsyncThunk('movingBlock/whatsAppActivityStatus', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  try {
    let isDisplayWhatsApp = false;

    if (state.movingEpiData.isDisplayWhatsApp.value) {
      thunkAPI.dispatch(showAppLoader());
      let contactNumber = '';
      if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
        contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
      } else {
        contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
      }
      var params = buildMovingApartmentExecution(state, contactNumber);
      const result = await ProviderManager.getProviderData('movingApartmentWhatsAppActivity', params);
      thunkAPI.dispatch(hideAppLoader());
      isDisplayWhatsApp = result.Body;
    }

    if (!isDisplayWhatsApp) { //IF NOT WHATSAPP => OPEN WORKORDER
      if (state.movingApartmentData.workOrderDetails.isOpen) {
        thunkAPI.dispatch(createWorkOrder(state.movingApartmentData.workOrderDetails));
      }
      thunkAPI.dispatch(
        movingBlockSlice.actions.report({
          actionType: 'Redirect to Service Message',
          status: 'Service Needed',
          messageText: 'Redirect to Service Message Displayed',
          products: state.movingApartmentData.products,
          param2: state.movingApartmentData.address.fullAddress,
          param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
          param6: state.movingApartmentData?.isCollaborationApproval,
          param7: state.movingApartmentData?.email.value,
          param9: state.movingApartmentData.workOrderDetails.reason,
          param10: state.movingApartmentData.workOrderDetails?.code
        })
      );
    }

    if (isDisplayWhatsApp) {
      thunkAPI.dispatch(
        movingBlockSlice.actions.report({
          actionType: 'Redirect to Service Message',
          status: 'Service Needed',
          messageText: 'Redirect to Whatsapp Message Displayed',
          products: state.movingApartmentData.products,
          param2: state.movingApartmentData.address.fullAddress,
          param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
          param6: state.movingApartmentData?.isCollaborationApproval,
          param7: state.movingApartmentData?.email.value,
          param9: state.movingApartmentData.workOrderDetails?.reason
        })
      );
    }

    if (data.isErrorPage) {
      thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage(data.pageID));
    }
    else {
      thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID(data.pageID));
      thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
    }

    return isDisplayWhatsApp;

  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(createWorkOrder(state.movingApartmentData.workOrderDetails));
    thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
  }
});

export const openWhatsAppChat = createAsyncThunk('movingBlock/openWhatsAppChat', async (data, thunkAPI) => {
  const state = thunkAPI.getState().movingBlock;
  try {
    thunkAPI.dispatch(showAppLoader());
    thunkAPI.dispatch(movingBlockSlice.actions.setActivityTime(null));

    thunkAPI.dispatch(
      movingBlockSlice.actions.report({
        actionType: 'Redirect to Service Message',
        status: 'Ongoing',
        messageText: 'Whatsapp Button Clicked',
        products: state.movingApartmentData.products,
        param2: state.movingApartmentData.address.fullAddress,
        param4: state.movingApartmentData?.address.selectedEntry?.infrastructure,
        param6: state.movingApartmentData?.isCollaborationApproval,
        param7: state.movingApartmentData?.email.value,
        param9: state.movingApartmentData.workOrderDetails?.reason,
        param10: state.movingApartmentData.workOrderDetails?.code
      })
    );

    let contactNumber = '';
    if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
      contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
    } else {
      contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
    }

    const messageText = whatsappText(state, state.movingApartmentData.workOrderDetails?.reason)

    var params = {
      phoneNumber: contactNumber,
      firstName: state.movingApartmentData.contactDetails.firstName,
      lastName: state.movingApartmentData.contactDetails.lastName,
      consumerId: state.movingApartmentData.selectedProducts[0]?.consumerId ?? '', //TODO: CHECK IF THIS CORRECT - IF MORE THEN ONE
      fullAddress: state.movingApartmentData.address.extendedFullAddress,
      messageText: messageText
    }

    const result = await ProviderManager.getProviderData('movingApartmentOpenWhatsApp', params);
    thunkAPI.dispatch(hideAppLoader());
    let isSuccess = result.Body.isSuccess;
    if (isSuccess) {
      thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID('WHATSAPP_SUCCESS'));
      thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
    }
    else {
      thunkAPI.dispatch(createWorkOrder(state.movingApartmentData.workOrderDetails));
      thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
    }

    return isSuccess;

  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(createWorkOrder(state.movingApartmentData.workOrderDetails));
    thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
  }
});

export const checkPinTechnician = createAsyncThunk('movingBlock/checkPinTechnician', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().movingBlock;
    let contactNumber = '';
    if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
      contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
    } else {
      contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
    }
    var params = buildMovingApartmentExecution(state, contactNumber);
    const result = await ProviderManager.getProviderData('movingApartmentCheckPinTechnician', params);
    thunkAPI.dispatch(hideAppLoader());

    if (result.Body.isTechnician) {
      thunkAPI.dispatch(movingBlockSlice.actions.setMovingWithTechnician(true));
      thunkAPI.dispatch(setTechnicianPage({ isPinTechnician: result.Body.isTechnician }));
    }
    else {
      thunkAPI.dispatch(movingBlockSlice.actions.setWhatsAppStatus(result.Body.isWhatsAppActive));
      const workOrderDetalis = getReasonForWorkOrder(result.Body.workOrderType);
      const workOrderCode = result.Body.workOrderType.fuType;
      const stepDescription = state.page == 'productsPage' ? "מסך בחירת מוצרים" : 'מסך סיכום';
      thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: workOrderCode, reason: workOrderDetalis.reasonText, stepDescription: stepDescription }));
      thunkAPI.dispatch(createWorkOrder({ code: workOrderCode, reason: workOrderDetalis.reasonText, stepDescription: stepDescription }));
      thunkAPI.dispatch(movingBlockSlice.actions.setErrorCode(''));
      thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID(workOrderDetalis.screenId));
      thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
    }

    return result.Body;
  }
  catch {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
  }
  finally {
  }
});

export const pinTechnicianAfterSlot = createAsyncThunk('movingBlock/pinTechnicianAfterSlot', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().movingBlock;
    thunkAPI.dispatch(showAppLoader());
    let contactNumber = '';
    if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
      contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
    } else {
      contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
    }
    var params = buildMovingApartmentExecution(state, contactNumber);

    const result = await ProviderManager.getProviderData('movingApartmentPinTechnicianAfterSlot', params);

    thunkAPI.dispatch(movingBlockSlice.actions.setWhatsAppStatus(result.Body.isWhatsAppActive));
    const workOrderDetalis = getReasonForWorkOrder(result.Body.workOrderType);
    const workOrderCode = result.Body.workOrderType.fuType;
    const stepDescription = state.page == 'productsPage' ? "מסך בחירת מוצרים" : 'מסך סיכום';
    thunkAPI.dispatch(createWorkOrder({ code: workOrderCode, reason: workOrderDetalis.reasonText, stepDescription: stepDescription }));
    thunkAPI.dispatch(movingBlockSlice.actions.setWorkOrderDetails({ isOpen: true, code: workOrderCode, reason: workOrderDetalis.reasonText, stepDescription: stepDescription }));
    thunkAPI.dispatch(movingBlockSlice.actions.setErrorCode(''));

    if (result.Body.isSummery) {
      if (state.movingApartmentData.isCheckedUpdateDeliveryAddress) {
        ProviderManager.getProviderData('movingApartmentAddressUpdate', params);
      }
      thunkAPI.dispatch(movingBlockSlice.actions.goToPage('completePage'));
    }
    else {
      thunkAPI.dispatch(movingBlockSlice.actions.setServiceMessageID(workOrderDetalis.screenId));
      thunkAPI.dispatch(movingBlockSlice.actions.goToPage('serviceMessagesPage'));
    }

    return result.Body;

  }
  catch {
    thunkAPI.dispatch(movingBlockSlice.actions.setErrorPage('GENERAL_ERROR'));
  }
  finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const createMemo = createAsyncThunk('movingBlock/createMemo', async (data, thunkAPI) => {

  try {
    const state = thunkAPI.getState().movingBlock;

    let contactNumber = '';
    if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
      contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
    } else {
      contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
    }

    let clientRequest = buildMovingApartmentExecution(state, contactNumber);

    let request = {
      code: data.memoID,
      description: data.description,
      clientRequest: clientRequest,
    }

    ProviderManager.getProviderData('createMemoMoving', request);
  }
  catch {

  }

});

export const addressUpdate = createAsyncThunk('movingBlock/addressUpdate', async (data, thunkAPI) => {

  try {
    const state = thunkAPI.getState().movingBlock;

    let contactNumber = '';
    if (thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value != '') {
      contactNumber = thunkAPI.getState().movingBlock.movingApartmentData.phoneNumber.value;
    } else {
      contactNumber = thunkAPI.getState().authentication.loginData.userDetails.contactNumber;
    }

    let params = buildMovingApartmentExecution(state, contactNumber);

    ProviderManager.getProviderData('movingApartmentAddressUpdate', params);
  }
  catch {

  }

});

const initialState = {
  movingEpiData: {},
  movingApartmentData: {
    page: '', //addressPage
    percent: 0,
    visits: 0,
    packagesList: [],
    paving: [],
    discountBlockId: [],
    selectedPackageBlockId: null,
    products: [],
    selectedProducts: [],
    selectedProductWithEquipment: '',
    movingWithTechnician: false,
    address: { extendedFullAddress: '' },
    isJetCustomer: false,
    isBarakUser: null,
    isCheckedUpdateDeliveryAddress: true,
    isCheckedCollaborationApproval: false,
    isCollaborationApproval: false,
    isDisplayCollaborationApproval: false,
    errorId: '',
    messageId: '',
    bottomTitle: '',
    primaryEmail : null,
    isDisplayMovingDate: true,
    isSubmit: false,
    email: {
      value: '',
      error: '',
    },
    phoneNumber: {
      value: '',
      error: '',
    },
    contactDetails: {
      firstName: '',
      lastName: '',
      phone: '',
    },
    workOrderDetails: {
      code: '',
      reason: '',
      stepDescription: '',
      memoId: '',
    },
    invoicingDeliveryType: '',
    technicianData: { selectedTechnicianTimeSlot: {}, timeSlotTitle: '', timeSlotShortTitle: '', timeSlots: [] },
    report: { actionType: '', status: '', messageText: '' },
    footerMessage: '',
    taskType: null,
    timeSlotNotAvailable: null,
    isTvApp: false,
    activityTime: null,
    pinTechnicianDetails: null,
    pinTechnicianAfterSlotDetails: null,
    isEndOfProcess: false,
    errorCode: '',
    technicianType: '',
  },
};

const movingBlockSlice = createSlice({
  name: 'movingBlock',
  initialState: initialState,
  reducers: {
    resetState: (state) => {
      return initialState;
    },
    initMoving: (state, action) => {
      state.movingEpiData = action.payload.movingEpiData;
      state.movingApartmentData.page = action.payload.page;
      state.movingApartmentData.packagesList = action.payload.movingEpiData.movingPackagesList;
      state.movingApartmentData.discountBlockId = [];
      state.movingEpiData.movingDiscounts?.expandedValue?.forEach(element => {
        if (element.isDisplayOffer?.value) {
          state.movingApartmentData.discountBlockId.push(element.contentLink.id)
        }
      });
    },
    goToPage: (state, action) => {
      state.movingApartmentData.page = action.payload;
    },
    redirectToLogin: (state, action) => { },
    setPercent: (state, action) => {
      state.movingApartmentData.percent = action.payload;
      // return {...state, movingApartmentData: {...state.movingApartmentData, percent: action.payload}}
    },
    setFooterMassage: (state, action) => {
      state.movingApartmentData.footerMessage = action.payload;
    },
    setIsCheckedUpdateDeliveryAddress: (state, action) => {
      state.movingApartmentData.isCheckedUpdateDeliveryAddress = action.payload;
    },
    setIsCheckedCollaborationApproval: (state, action) => {
      state.movingApartmentData.isCollaborationApproval = action.payload;
    },
    setAddressData: (state, action) => {
      state.movingApartmentData.address = action.payload;
    },
    setExtendedFullAddress: (state, action) => {
      state.movingApartmentData.address.extendedFullAddress = action.payload;
    },
    setIsSubmit: (state, action) => {
      state.movingApartmentData.isSubmit = action.payload;
    },
    setTimeSlotNotAvailable: (state, action) => {
      state.movingApartmentData.timeSlotNotAvailable = action.payload;
    },
    setSelectedEntry: (state, action) => {
      //state.movingApartmentData.address.selectedEntry = action.payload;
      state.movingApartmentData.address.selectedEntry = Object.assign({}, state.movingApartmentData.address.selectedEntry, action.payload); //this code keep zipCode on selectedEntry
    },
    setSelectedProducts: (state, action) => {
      if (action.payload.isChecked) {
        state.movingApartmentData.selectedProducts.push(action.payload.product);
      } else {
        state.movingApartmentData.selectedProducts = state.movingApartmentData.selectedProducts?.filter(
          (product) => product.productId != action.payload.product.productId
        );
      }
    },
    setSelectedPackageBlockId: (state, action) => {
      state.movingApartmentData.selectedPackageBlockId = action.payload;
    },
    setEmailError: (state, action) => {
      state.movingApartmentData.email.error = action.payload;
    },
    setPhoneNumberError: (state, action) => {
      state.movingApartmentData.phoneNumber.error = action.payload;
    },
    setInvoicingDeliveryDetails: (state, action) => {
      if (action.payload.type == 'email') {
        state.movingApartmentData.email.value = action.payload.value;
      } else {
        state.movingApartmentData.phoneNumber.value = action.payload.value;
      }
    },
    setSelectedInvoicingDeliveryType: (state, action) => {
      state.movingApartmentData.invoicingDeliveryType = action.payload;
    },
    setTechnicianSelectedDay: (state, action) => {
      state.movingApartmentData.technicianData.timeSlots.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.isSelected = true;
          x.hours[0].isSelected = true;
          const selectedTechnicianTime = {
            year: x.year,
            month: x.month,
            day: x.day,
            startDate: (x.hours && x.hours.length > 0 ? x.hours[0].startDate : ''),
            endDate: (x.hours && x.hours.length > 0 ? x.hours[0].endDate : ''),
            fullDate: getShortTechnicianTimeDisplay(x.hours[0].startDate, x.hours[0].endDate)
          };
          state.movingApartmentData.technicianData.selectedTechnicianTimeSlot = selectedTechnicianTime;
        } else {
          x.isSelected = false;
        }
        return x;
      });
    },
    setTechnicianSelectedTime: (state, action) => {
      state.movingApartmentData.technicianData.timeSlots.map(function (x) {
        if (x.year == action.payload.year && x.month == action.payload.month && x.day == action.payload.day) {
          x.hours.map(function (hour) {
            if (hour.startDate == action.payload.startDate) {
              hour.isSelected = true;
            } else {
              hour.isSelected = false;
            }
            return hour;
          });
        }
        return x;
      });
      state.movingApartmentData.technicianData.selectedTechnicianTimeSlot = action.payload;
      state.movingApartmentData.technicianData.selectedTechnicianTimeSlot.fullDate = getShortTechnicianTimeDisplay(
        action.payload.startDate,
        action.payload.endDate
      );
    },
    setErrorPage: (state, action) => {
      state.movingApartmentData.page = 'errorPage';
      state.movingApartmentData.errorId = action.payload;
    },
    setTaskType: (state, action) => {
      state.movingApartmentData.taskType = action.payload;
    },
    setServiceMessageID: (state, action) => {
      state.movingApartmentData.messageId = action.payload;
    },
    setMovingWithTechnician: (state, action) => {
      state.movingApartmentData.movingWithTechnician = action.payload;
    },
    setContactDetails: (state, action) => {
      state.movingApartmentData.contactDetails.firstName = action.payload.firstName;
      state.movingApartmentData.contactDetails.lastName = action.payload.lastName;
      state.movingApartmentData.contactDetails.phone = action.payload.phone;
    },
    selectedProductWithEquipment: (state, action) => {
      state.movingApartmentData.selectedProductWithEquipment = action.payload;
    },
    setIsTvApp: (state, action) => {
      state.movingApartmentData.isTvApp = action.payload;
    },
    report: {
      reducer(state, action) { },
      prepare(payload) {
        const products = payload.products?.map((x) => {
          return "(" + x.productDescription + ")";
        })?.join();
        const selectedProducts = payload.selectedProducts?.map((x) => {
          return "(" + x.productDescription + ")";
        })?.join();
        return {
          payload: {
            actionType: payload.actionType,
            status: payload.status,
            messageText: payload.messageText,
            products: products,
            param2: payload.param2,
            selectedProducts: selectedProducts,
            param4: payload.param4,
            param5: payload.param5,
            param6: payload.param6,
            param7: payload.param7,
            param8: payload.param8,
            param9: payload.param9,
            param10: payload.param10,
          },
        };
      },
    },
    reportAnalytics: (state, action) => { },
    setActivityTime: (state, action) => {
      state.movingApartmentData.activityTime = action.payload;
    },
    setWorkOrderDetails: (state, action) => {
      state.movingApartmentData.workOrderDetails = {
        isOpen: action.payload.isOpen,
        code: action.payload.code,
        reason: action.payload.reason,
        stepDescription: action.payload.stepDescription,
        memoId: action.payload.memoId,
      }
    },
    setWhatsAppStatus: (state, action) => {
      state.movingApartmentData.activityTime = action.payload;
    },
    setPinTechnicianDetails: (state, action) => {
      state.movingApartmentData.pinTechnicianDetails = action.payload;
    },
    setIsEndOfProcess: (state, action) => {
      state.movingApartmentData.isEndOfProcess = action.payload;
    },
    setErrorCode: (state, action) => {
      state.movingApartmentData.errorCode = action.payload;
    },
    setTechnicianType: (state, action) => {
      state.movingApartmentData.technicianType = action.payload;
    },
  },
  extraReducers: {
    [getProducts.fulfilled]: (state, action) => {
      if (action.payload != null) {
        state.movingApartmentData.products = action.payload.products;
        state.movingApartmentData.isJetCustomer = action.payload.isJetCustomer;
        state.movingApartmentData.isBarakUser = action.payload.isBarakUser;
        state.movingApartmentData.primaryEmail = action.payload.primaryEmail;
        state.movingApartmentData.isCollaborationApproval = action.payload.collaborationApproval;
        state.movingApartmentData.isDisplayCollaborationApproval = !action.payload.collaborationApproval;
        state.movingApartmentData.movingWithTechnician = action.payload.movingWithTechnician;
      }
    },
    [MovingApartmentExecution.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
    },
    [checkFiberAddressInfraStructure.fulfilled]: (state, action) => { },
    [getAddressEntries.fulfilled]: (state, action) => { },
    [bezeqCheckTechnicianType.fulfilled]: (state, action) => { },
    [getTechnicianTimeSlots.fulfilled]: (state, action) => {
      let technicianTimes = getCustomTechnicianTimes(action.payload);
      if (technicianTimes?.length > 0) {
        technicianTimes[0].isSelected = true;
        if (technicianTimes[0].hours?.length > 0) {
          technicianTimes[0].hours[0].isSelected = true;
          state.movingApartmentData.technicianData.selectedTechnicianTimeSlot = {
            year: technicianTimes[0].year,
            month: technicianTimes[0].month,
            day: technicianTimes[0].day,
            startDate: technicianTimes[0].hours[0].startDate,
            endDate: technicianTimes[0].hours[0].endDate,
          };
          state.movingApartmentData.technicianData.timeSlotTitle = getTechnicianTimeDisplay(
            technicianTimes[0].hours[0].startDate,
            technicianTimes[0].hours[0].endDate
          );
          state.movingApartmentData.technicianData.timeSlotShortTitle = getShortTechnicianTimeDisplay(
            technicianTimes[0].hours[0].startDate,
            technicianTimes[0].hours[0].endDate
          );
          state.movingApartmentData.technicianData.selectedTechnicianTimeSlot.fullDate = getShortTechnicianTimeDisplay(
            technicianTimes[0].hours[0].startDate,
            technicianTimes[0].hours[0].endDate
          );
        }
      }
      state.movingApartmentData.technicianData.timeSlots = technicianTimes;
    },
    [GetPriceAndTechnicianType.fulfilled]: (state, action) => {
      if (action.payload != null) {
        state.movingApartmentData.paving = action.payload
      }
    },
    [createWorkOrder.fulfilled]: (state, action) => { },
    [whatsAppActivityStatus.fulfilled]: (state, action) => {
      if (action.payload != null) {
        state.movingApartmentData.activityTime = action.payload;
      }
      else {
        state.movingApartmentData.activityTime = false;
      }
    },
    [openWhatsAppChat.fulfilled]: (state, action) => { },
    [checkPinTechnician.fulfilled]: (state, action) => {
      if (action.payload != null) {
        state.movingApartmentData.pinTechnicianDetails = action.payload;
      }
    },
    [pinTechnicianAfterSlot.fulfilled]: (state, action) => {
      if (action.payload != null) {
        state.movingApartmentData.pinTechnicianAfterSlotDetails = action.payload;
      }
    },
    [addressUpdate.fulfilled]: (state, action) => { },
    [createMemo.fulfilled]: (state, action) => { },
    [setTechnicianPage.fulfilled]: (state, action) => { },
  },
});

export const {
  resetState,
  initMoving,
  goToPage,
  setIsDisplayMovingDate,
  redirectToLogin,
  setUserDetails,
  setIsCheckedUpdateDeliveryAddress,
  setIsCheckedCollaborationApproval,
  setIsCollaborationApproval,
  setPercent,
  setFooterMassage,
  setSelectedProducts,
  setIsSubmit,
  setAddressData,
  setErrorPage,
  setTaskType,
  setServiceMessageID,
  setEmailError,
  setPhoneNumberError,
  setSelectedInvoicingDeliveryType,
  setSelectedPackageBlockId,
  setSelectedEntry,
  setTechnicianSelectedDay,
  setTechnicianSelectedTime,
  setInvoicingDeliveryDetails,
  setMovingWithTechnician,
  setContactDetails,
  selectedProductWithEquipment,
  report,
  reportAnalytics,
  setTimeSlotNotAvailable,
  setIsTvApp,
  setActivityTime,
  setWorkOrderDetails,
  setWhatsAppStatus,
  setPinTechnicianDetails,
  setIsEndOfProcess,
  setErrorCode,
  setExtendedFullAddress,
  setTechnicianType
} = movingBlockSlice.actions;

export default movingBlockSlice.reducer;

function getCustomTechnicianTimes(technicianTimesList) {
  if (!technicianTimesList) {
    return;
  }

  const groups = technicianTimesList.reduce((groups, item) => {
    const date = item.start.split('T')[0];
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});

  const groupArrays = Object.keys(groups).map((date) => {
    return {
      date,
      hours: groups[date],
    };
  });

  let technicianTimes = [];

  groupArrays.forEach((item) => {
    let currentDate = new Date(item.date);
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let monthName = getMonthName(currentDate.getMonth());
    let day = currentDate.getDate();
    let dayOfWeek = getDayOfWeek(currentDate.getDay());
    let hours = [];

    item.hours.forEach((hour) => {
      let startDate = new Date(hour.start);
      let endDate = new Date(hour.end);

      const hourItem = {
        startDate: hour.start,
        endDate: hour.end,
        start: ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2),
        end: ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2),
        isSelected: false,
      };

      hours.push(hourItem);
    });

    let technicianTime = {
      year: year,
      month: month,
      monthName: monthName,
      day: day,
      dayOfWeek: dayOfWeek,
      hours: hours,
      isSelected: false,
    };

    technicianTimes.push(technicianTime);
  });

  return technicianTimes;
}
function getTechnicianTimeDisplay(start, end) {
  let startDate = new Date(start);
  let endDate = new Date(end);

  const dayOfWeek = getDayOfWeek(startDate.getDay());
  const dateToDisplay = formatDate(startDate);

  const startHour = ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2);
  const endHour = ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2);

  let selectedTechnicianTimeDisplay = `${dayOfWeek} ${dateToDisplay} בין ${startHour}-${endHour}`;
  return selectedTechnicianTimeDisplay;
}
function getShortTechnicianTimeDisplay(start, end) {
  let startDate = new Date(start);
  let endDate = new Date(end);

  const dayOfWeek = getShortDayOfWeek(startDate.getDay());
  const dateToDisplay = formatDate(startDate);

  const startHour = ('0' + startDate.getHours()).slice(-2) + ':' + ('0' + startDate.getMinutes()).slice(-2);
  const endHour = ('0' + endDate.getHours()).slice(-2) + ':' + ('0' + endDate.getMinutes()).slice(-2);

  let selectedTechnicianTimeDisplay = `${dayOfWeek} ${dateToDisplay} בשעות ${startHour}-${endHour}`;
  return selectedTechnicianTimeDisplay;
}
function formatDate(date) {
  const yyyy = date.getFullYear().toString().substr(-2);
  let mm = date.getMonth() + 1;
  let dd = date.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  const dateToDisplay = dd + '.' + mm + '.' + yyyy;
  return dateToDisplay;
}
function getMonthName(month) {
  const monthNames = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
  return monthNames[month];
}
function getDayOfWeek(dayOfWeek) {
  const weekDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  return weekDays[dayOfWeek];
}
function getShortDayOfWeek(dayOfWeek) {
  const weekDays = ["א',", "ב',", "ג',", "ד',", "ה',", "ו',", "ש',"];
  return weekDays[dayOfWeek];
}
function buildMovingApartmentExecution(state, contactNumber) {
  let prod = [];
  const addHoursTechnicianTimeSlots = state.movingEpiData.addHoursTechnicianTimeSlots.value?.toString() ?? '0';
  if (state.movingApartmentData.selectedProducts?.length > 0) {
    prod = state.movingApartmentData.selectedProducts;
  } else {
    prod = state.movingApartmentData.products;
  }
  var params = {
    taskType: state.movingApartmentData.taskType ?? null,
    nextOfferBlockId: state.movingApartmentData.selectedPackageBlockId,
    discountBlockId: state.movingApartmentData.discountBlockId,
    phoneNumber: contactNumber,
    collaborationApproval: state.movingApartmentData.isCollaborationApproval,
    mailingUpdate: state.movingApartmentData.isCheckedUpdateDeliveryAddress,
    emailAddress: state.movingApartmentData.email?.value,
    addHoursTechnicianTimeSlots: addHoursTechnicianTimeSlots,
    addressDetails: {
      cityName: state.movingApartmentData.address.selectedAddress?.cityName,
      streetName: state.movingApartmentData.address.selectedAddress?.streetName,
      cityCode: state.movingApartmentData.address.selectedAddress?.cityCode,
      streetCode: state.movingApartmentData.address.selectedAddress?.streetCode,
      citySemel: state.movingApartmentData.address.selectedAddress?.citySemel,
      streetSemel: state.movingApartmentData.address.selectedAddress?.streetSemel,
      entry: state.movingApartmentData.address.selectedEntry?.entry ?? null,
      floor: state.movingApartmentData.address.selectedAddress?.floor,
      homeNum: state.movingApartmentData.address.selectedAddress?.home,
      apartment: state.movingApartmentData.address.selectedAddress?.apartment,
      zipCode: state.movingApartmentData.address.selectedEntry?.zipCode,
      infrastructure: state.movingApartmentData.address.selectedEntry?.infrastructure ?? null,
      siteType: state.movingApartmentData.address.selectedEntry?.siteType ?? null,
      gponBuildingType: state.movingApartmentData.address.selectedEntry?.gponBuildingType ?? null,
      streetGisSemel: state.movingApartmentData.address.selectedAddress?.streetGisSemel,
    },
    contactDetails: {
      firstName: state.movingApartmentData.contactDetails.firstName,
      lastName: state.movingApartmentData.contactDetails.lastName,
      phoneNumber: state.movingApartmentData.contactDetails.phone,
    },
    startDate: state.movingApartmentData.technicianData?.selectedTechnicianTimeSlot.startDate ?? null,
    endDate: state.movingApartmentData.technicianData?.selectedTechnicianTimeSlot.endDate ?? null,
    products: prod,
    whatsAppRequest: {
      errorDescription: state.movingApartmentData.workOrderDetails?.reason ?? ''
    },
    errorInfo: {
      errorCode: state.movingApartmentData.errorCode
    }
  };

  if (params.startDate == null) {
    delete params.startDate;
    delete params.endDate;
  }

  return params;
}
function isUpgradeToFiber(movingApartment) {
  const fiberList = ['FB', 'BF', 'BC'];
  const infrastructure = movingApartment.movingApartmentData?.address?.selectedEntry?.infrastructure;
  let hasFiberNewAddress = infrastructure ? fiberList.includes(infrastructure) : false;
  let hasFiberOldAddress = movingApartment.movingApartmentData.products?.find((x) => x.productType?.toLowerCase() == 'internet' && fiberList.includes(x.infrastructure)) ? true : false;
  return (hasFiberNewAddress && !hasFiberOldAddress)
}

function getReasonForWorkOrder(workOrderType) {
  let obj = {
    reasonText: '',
    memoId: '',
    workOrderCode: '',
    screenId: ''
  }

  switch (workOrderType.errorScreenId) {
    case 3:
      obj.screenId = 'OPTICAL_FIBER_FOUNDED';
      break;
    case 4:
      obj.screenId = 'LAST_DETAILS';
      break;
    default:
      obj.screenId = 'LAST_DETAILS';
      break;
  }

  switch (workOrderType.reasonType) {
    case "1":
      obj.reasonText = `סיבה 1 - מעבר מסיבים לנחושת - תואם טכנאי ${window.Config.brand_Name_HE}`;
      obj.memoId = 'M';
      obj.workOrderCode = 'MOV5';
      break;
    case "1.1":
      obj.reasonText = 'סיבה 1.1 - מעבר מסיבים לנחושת , בבזק נדרש טכנאי בית';
      obj.memoId = 'A';
      obj.workOrderCode = 'CB23';
      break;
    case "2":
      obj.reasonText = 'סיבה 2 - יש צורך בשינוי מהירות, המהירות הקיימת לא נתמכת בכתובת החדשה';
      obj.memoId = 'M';
      obj.workOrderCode = 'MOV5';
      break;
    case '3':
      obj.reasonText = 'סיבה 3 - אפשרי לשדרוג מנחושת לסיבים, תואם טכנאי ללא הזמנת מעבר דירה';
      obj.memoId = 'M';
      obj.workOrderCode = 'MOV4';
      break;
    case "3.1":
      obj.reasonText = 'סיבה 3.1 - אפשרות לשדרוג מנחושת לסיבים, בבזק נדרש טכנאי בית';
      obj.memoId = 'A';
      obj.workOrderCode = 'MOV2';
      break;
    case "4":
      obj.reasonText = 'סיבה 4 - מעבר מנחושת לנחושת, נדרש לפתוח הזמנת מעבר דירה';
      obj.memoId = 'M';
      obj.workOrderCode = 'MOV5';
      break;
    case "4.1":
      obj.reasonText = 'סיבה 4.1 - מעבר מנחושת לנחושת , בבזק נדרש טכנאי בית';
      obj.memoId = '';//אין
      obj.workOrderCode = 'CB23';
      break;
    case "5":
      obj.reasonText = 'סיבה 5 - מוצר שלא הוסב ל JET';
      obj.memoId = 'A';
      obj.workOrderCode = 'CB23';
      break;
    case "6":
      obj.reasonText = 'סיבה 6 - מוצר שלא הוסב לJET - אפשרי לשדרג לסיבים';
      obj.memoId = 'A';
      obj.workOrderCode = 'MOV2';
      break;
    case "9":
      obj.reasonText = 'סיבה 9 - שגיאה אפליקטיבית בתהליך נעיצת טכנאי';
      obj.memoId = 'A';
      obj.workOrderCode = 'CB23';
      break;
    case "11":
      obj.reasonText = 'סיבה 11 - יש צורך בשינוי ציוד בעקבות שינוי סוג תשתית';
      obj.memoId = 'M';
      obj.workOrderCode = 'MOV5';
      break;
    default:
      obj.reasonText = 'סיבה 9 - שגיאה אפליקטיבית';
      obj.memoId = 'A';
      obj.workOrderCode = 'CB23';
      break;

  }
  return obj;

}

function workOrderRequest(movingApartment, userDetails, code, reason, stepDescription, memoID) {
  const fiberList = ['FB', 'BF', 'BC'];
  const banList = movingApartment.selectedProducts?.reduce(function (bans, product) {
    if (product.ban && !bans.includes(product.ban)) {
      bans.push(product.ban);
    }
    return bans;
  }, []);
  const psidList = movingApartment.selectedProducts?.reduce(function (psids, product) {
    if (product.psid && !psids.includes(product.psid)) {
      psids.push(product.psid);
    }
    return psids;
  }, []);
  const address = movingApartment.address.selectedAddress;
  const selectedEntry = movingApartment.address.selectedEntry;
  const hasFiber = fiberList.includes(selectedEntry?.infrastructure);
  const products = movingApartment.selectedProducts
    ?.map((x) => {
      return x.productDescription;
    })
    ?.join();
  const externalIdNum =
    movingApartment.selectedProducts?.length == 1
      ? movingApartment.selectedProducts[0].consumerId
      : movingApartment.selectedProducts?.find((x) => !x.consumerId.startsWith('BI'))?.consumerId;
  const selectedTimeSlots = movingApartment.technicianData?.selectedTechnicianTimeSlot?.startDate
    ? getTechnicianTimeDisplay(
      movingApartment.technicianData.selectedTechnicianTimeSlot.startDate,
      movingApartment.technicianData.selectedTechnicianTimeSlot.endDate
    )
    : null;

  let request = {
    orderType: 'MOVING_APARTMENT',
    identityNumber: userDetails.IDNumber,
    externalIdNum: externalIdNum,
    firstName: userDetails.firstName,
    lastName: userDetails.lastName,
    errorCode: code,
    errorDescription: reason,
    subscriber: userDetails.contactNumber,
    banList: banList,
    psidList: psidList,
    movingApartment: {
      isCheckedUpdateDeliveryAddress: movingApartment.isCheckedUpdateDeliveryAddress,
      addressDetails: {
        cityName: address.cityName,
        streetName: address.streetName,
        cityCode: address.cityCode,
        streetCode: address.streetCode,
        citySemel: '',
        streetSemel: '',
        homeNum: address.home,
        apartment: address.apartment,
        floor: address.floor,
        zipCode: selectedEntry?.zipCode,
        infrastructure: '',
        entry: selectedEntry?.entry,
      },
      technicianDate: selectedTimeSlots,
      hasFiberInfrastructure: hasFiber,
      infrastructure: selectedEntry?.infrastructure,
      products: products,
      reason: reason,
      stepDescription: stepDescription,
      memoID: memoID ?? ''
    },
    saleJet: null,
  };

  return request;
}

function googleAnalitycsEndOfProcess(event, title, error, step, action, funnel_name) {
  gtag4({
    event: event,
    title: title,
    error: error,
    step: step,
    action: action,
    funnel_name: funnel_name,
  });
}

function whatsappText(state, errorReason) {
  const movingApartment = state.movingApartmentData;
  let data = [];
  const consumerId = movingApartment.selectedProducts[0]?.consumerId ?? '';
  data.push("לקוח: " + consumerId);
  data.push(`ביקש לבצע מעבר דירה באתר ${window.Config.brand_Name_HE}`);
  const fullAddress = movingApartment.address.extendedFullAddress;
  data.push("עובר לכתובת: " + fullAddress);
  const isCheckedUpdateDeliveryAddress = (movingApartment.isCheckedUpdateDeliveryAddress ? 'עם' : 'ללא') + ' עדכון כתובת למשלוח דואר ';
  data.push(isCheckedUpdateDeliveryAddress);
  const products = movingApartment.selectedProducts?.map((product, index) => { return product.productDescription })?.join() ?? '';
  data.push("בחר להעביר מוצר: " + products);
  const timeSlotDate = movingApartment.technicianData?.selectedTechnicianTimeSlot?.fullDate ?? '';
  if (timeSlotDate != '' && timeSlotDate != null) {
    data.push("מועד טכנאי שנבחר:" + timeSlotDate);
  }
  data.push("סיבת כישלון:" + errorReason);
  return data.join(',');
}
